<div class="button-wrapper">

    <button type="button" mat-raised-button color="primary" class="reverse" [matTooltip]="tooltip | striphtml">                
        <span [innerHtml]="title | striphtml"></span>
        <mat-icon>{{icon}}</mat-icon>
    </button>
    
    <p class="text-description" [innerHTML]="description | striphtml"></p>

</div>
